import { ScrollToTop } from 'components';
import { AlertContextProvider, ToastContextProvider, useSettings } from 'hooks';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, theme } from 'styles';
import { KEY_ENABLE_CURRENT_LOCATION, KEY_ENABLE_INTERESTED_LOCATIONS } from 'data/constants';
import { useEffect, lazy, Suspense } from 'react';
import nativeAppSettingsFunctions from 'mobile-bridge/app-settings-functions';
import FullScreenLoading from 'components/loading/FullScreenLoading';

import i18n from './i18n/i18n';

const HomePage = lazy(() => import('./pages/home/Home'));
const SearchPage = lazy(() => import('./pages/search/Search'));
const BookmarkPage = lazy(() => import('./pages/bookmark/default/Bookmark'));
const AddBookmarkPage = lazy(() => import('./pages/bookmark/add/AddBookmark'));
const RadarPage = lazy(() => import('./pages/radar/Radar'));
const SatellitePage = lazy(() => import('./pages/satellite/Satellite'));
const SettingPage = lazy(() => import('./pages/setting/default/Setting'));
const SettingDetailPage = lazy(() => import('./pages/setting/settingDetail/SettingDetail'));
const PolicyPage = lazy(() => import('./pages/setting/policy/Policy'));

function App(props) {
  const { setEnableCurrentLocation, setEnableInterestedLocations } = useSettings();

  useEffect(() => {
    if (
      localStorage.getItem(KEY_ENABLE_CURRENT_LOCATION) === null &&
      localStorage.getItem(KEY_ENABLE_INTERESTED_LOCATIONS) === null
    ) {
      setEnableCurrentLocation(true);
      localStorage.setItem(KEY_ENABLE_CURRENT_LOCATION, true);
      nativeAppSettingsFunctions.setSharedPreferenceBoolean(KEY_ENABLE_CURRENT_LOCATION, true);
    }
  }, []);

  // 상단 주소창 높이
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <AlertContextProvider>
          <ToastContextProvider>
            <BrowserRouter>
              <GlobalStyles />
              <ScrollToTop />
              <Routes>
                <Route path="/" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <HomePage />
                  </Suspense>
                } />
                <Route path="/search" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <SearchPage />
                  </Suspense>
                } />
                <Route path="/bookmark" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <BookmarkPage />
                  </Suspense>
                } />
                <Route path="/bookmark/add" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <AddBookmarkPage />
                  </Suspense>
                } />
                <Route path="/radar" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <RadarPage />
                  </Suspense>
                } />
                <Route path="/satellite" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <SatellitePage />
                  </Suspense>
                } />
                <Route path="/setting" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <SettingPage />
                  </Suspense>
                } />
                <Route path="/setting/detail" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <SettingDetailPage />
                  </Suspense>
                } />
                <Route path="/setting/policy" element={
                  <Suspense fallback={<FullScreenLoading />}>
                    <PolicyPage />
                  </Suspense>
                } />
              </Routes>
            </BrowserRouter>
          </ToastContextProvider>
        </AlertContextProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
